export default function FocusRef(this: any, compile: any){
  const ref = compile.errors && compile.errors.length > 0 ? compile.errors[0].dataPath.replace(/./, '') : null;
  return ref;
}
